import React, { useState, useEffect, Fragment } from "react"
import { motion } from "framer-motion"
import GridItem from "./GridItem"
import AddPost from "./AddPost"
import { useAuth } from "../firebase/useAuth"
import { Loading } from "../helpers/components"
import noPost from "../assets/noPost.svg"
import moment from "moment"

export default function Grid() {
  const [currentUser, profileIsLoading] = useAuth()
  const [postsSortedByDate, setPostsSortedByDate] = useState([])

  useEffect(() => {
    setPostsSortedByDate(currentUser?.posts?.sort((a, b) => moment(a.plannedFor) - moment(b.plannedFor)))
  }, [currentUser])
  

	if (profileIsLoading) return <Loading title="Chargement..." />

	if (currentUser?.posts?.length < 1)
		return (
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
        <AddPost />
        <div className="noPost">
          <img className="img" src={noPost} alt="No posts published yet" />
          <div className="text">
            Il n'y a rien ici 😯 Cliquez sur le bouton au dessus pour plannifier
            votre premier post
          </div>
        </div>
      </motion.div>
		)

	return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <AddPost />
      <div className="grid">
        {currentUser &&
          postsSortedByDate.map((post, i) => (
            <Fragment key={i}>
              {i < 30 && <GridItem post={post} index={i} />}
            </Fragment>
          ))}
      </div>
    </motion.div>
	)
}
